import React from "react"
import Heading from "../components/heading"
import Layout from "../components/layout"

const NotFound = () => (
  <Layout>
    <Heading size="xl">Oops, that's a 404</Heading>
  </Layout>
)

export default  NotFound
